const initialState = {
  status: "all",
  search: "",
};

export default initialState;
